import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import FormBuilder from "@/pages/lead-capture/components/FormBuilder";
import { fetchApi } from "@/services/apiService";

export default function EditLeadCaptureFormPage() {
  const { formId } = useParams<{ formId: string }>();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!formId) return;
    setIsLoading(true);
    fetchApi<any>(`/lead-capture/forms/${formId}`, undefined, null)
      .then((res) => {
        const data = res?.data || res;
        if (data) {
          setForm({
            id: String(data.id),
            title: data.title || data.name || "Web Form",
            description: data.description || "",
            fields: Array.isArray(data.fields) ? data.fields : (typeof data.fields === "string" ? JSON.parse(data.fields || "[]") : []),
            status: data.status || "Active",
            redirect_url: data.redirect_url || "",
            submit_button_text: data.submit_button_text || "Submit Inquiry",
            privacy_policy_checkbox: data.privacy_policy_checkbox !== false,
            success_message: data.success_message || "Thank you! We'll contact you shortly.",
            project_id: data.project_id || null,
          });
        }
      })
      .catch((err) => console.error("Failed to load form:", err))
      .finally(() => setIsLoading(false));
  }, [formId]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center text-gray-500">
          <i className="ri-loader-4-line text-2xl animate-spin text-indigo-600 block mb-2" />
          Loading form configuration...
        </div>
      </div>
    );
  }

  if (!form) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <i className="ri-error-warning-line text-4xl text-gray-300 block mb-2" />
          <p className="text-gray-500">Form not found</p>
          <button
            onClick={() => navigate("/lead-capture")}
            className="mt-3 text-sm text-indigo-600 hover:text-indigo-700 cursor-pointer font-semibold"
          >
            Back to Lead Capture
          </button>
        </div>
      </div>
    );
  }

  return (
    <FormBuilder
      initialTitle={form.title}
      initialSubtitle={form.description}
      initialFields={form.fields}
      initialSubmitText={form.submit_button_text}
      initialPrivacyCheckbox={form.privacy_policy_checkbox}
      initialSuccessMessage={form.success_message}
      initialMappedProjectId={form.project_id}
      formId={form.id}
      isEdit
    />
  );
}